/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "2b964e4973242f25c68147550434a5230d57118e";
